const greatestCommonDivisor = (a: number, b: number): number => {
  return b === 0 ? a : greatestCommonDivisor(b, a % b);
};

export const aspectRatioString = (width: number, height: number): string => {
  const ratio = greatestCommonDivisor(width, height);

  return `${(width as number) / ratio}:${(height as number) / ratio}`;
};
